A status of a workflow process.
